import { getAll } from '@/api/relances/index';
import i18n from '@/i18n';
import genererCritereRelance from '@/services/relances/genererRelanceCritere';
import * as types from './relance-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRelance(),
    critereRechercheFactureTiers: genererCritereRelance(),
    lastPayload: {},
    retourDetail: null,
  };
}
const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL_COUNT](state, count) {
    state.totalCount = count;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_CRITERE_RECHERCHE_COMMUN](state, critere) {
    state.critereRechercheFactureTiers = critere;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_RETOUR_DETAIL](state, retour) {
    state.retourDetail = retour;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadRelances({ commit }, relanceFilter) {
    const response = (await getAll(relanceFilter)).data.result;

    response.items.forEach((relance) => {
      relance.relanceLibelle = i18n.t('relance.relanceMaj') + ' ' + relance.numRelance
        + ' - ';
      relance.relanceLibelle += relance.mouvementsClientIds.length > 1
        ? relance.payeur.nomCommercial : relance.mouvementsClients[0].libelle;
      relance.selected = false;
    });
    commit(types.SET_ITEMS, response.items);
    commit(types.SET_LAST_PAYLOAD, relanceFilter);
    commit(types.SET_TOTAL_COUNT, response.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  critereRechercheFactureTiers: state => {
    return state.critereRechercheFactureTiers;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  retourDetail: state => {
    return state.retourDetail;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
